import { A, Callout, ContactBlock, P, Section, Ul, card } from './LegalDoc'
import { CONTACT_EMAIL, OPERATOR_NAME } from './versions'

export default function DisclaimerContent() {
  return (
    <div style={card}>
      <Section title="AI-generated content">
        <Callout tone="warn" title="Branon's learning content is generated by artificial intelligence.">
          <P>
            Explanations, practice questions, chatbot answers ("Chinni"), cheat sheets, and exam
            simulations are produced by AI (including Claude AI by Anthropic). While we work hard on
            quality:
          </P>
          <Ul
            items={[
              'AI can make mistakes or give incomplete information',
              'Answers may not always be fully accurate',
              'AI may misunderstand complex or ambiguous questions',
              'Cached answers may become outdated over time',
            ]}
          />
          <P>
            <strong>Always cross-check important answers</strong> against your textbook, your
            teachers, and official study materials.
          </P>
        </Callout>
      </Section>

      <Section title="Educational use only">
        <P>
          Branon supports students in grades 6–12 and is designed to <strong>supplement</strong>{' '}
          learning — it is not a replacement for textbooks, teacher instruction, school curriculum,
          or official examination-preparation materials.
        </P>
      </Section>

      <Section title="No guarantee of academic results">
        <P>Branon provides learning tools but cannot guarantee:</P>
        <Ul
          items={[
            'Improved test scores or grades',
            'Specific learning outcomes or examination success',
            'Admission to any school, program, or institution',
          ]}
        />
        <P>
          Success depends on individual effort, regular practice, teacher guidance, and study
          habits.
        </P>
      </Section>

      <Section title="Curriculum alignment and exam formats">
        <Ul
          items={[
            'Content is aligned with common Indian curricula for grades 6–12, but board and state variations exist',
            'Syllabi and official exam patterns change; content may not always reflect the very latest official changes',
            'Exam simulations are practice tools — always verify the current official exam pattern, marking scheme, and syllabus from official sources before an examination',
          ]}
        />
      </Section>

      <Section title="Parental involvement">
        <P>We recommend parents stay involved in their child's use of Branon:</P>
        <Ul
          items={[
            'Usage patterns and time spent',
            'Progress and performance',
            'Understanding of concepts, not just completion',
            'Balance between Branon and other study methods',
          ]}
        />
        <P>
          Parents can follow progress through the Branon parent app (family subscriptions) or
          through their school's parent portal (school-provided access).
        </P>
      </Section>

      <Section title="Service availability">
        <P>Branon is provided "as is" and "as available", without warranty of:</P>
        <Ul
          items={[
            'Uninterrupted or error-free operation',
            'Compatibility with every device',
            'Availability during maintenance or outages',
          ]}
        />
        <Callout tone="warn">
          <P>
            Do not rely solely on Branon for time-sensitive academic work — keep your own notes and
            backups of important information.
          </P>
        </Callout>
      </Section>

      <Section title="Third-party dependencies">
        <P>
          Branon depends on third-party services (Anthropic, OpenAI, Supabase, Razorpay, Resend).
          Disruptions or changes by these providers may affect Branon, and we are not liable for
          failures caused by them.
        </P>
      </Section>

      <Section title="Limitation of liability">
        <P>
          To the maximum extent permitted by law, {OPERATOR_NAME} is not liable for incorrect AI
          responses, academic outcomes, technical issues, data loss, third-party service failures,
          or decisions made based on platform content. The liability terms of the agreement that
          governs your access apply: the <A href="/terms">Terms of Service</A> shown in your app
          (or your school's agreement with us, for school-provided access).
        </P>
      </Section>

      <Section title="Governing law">
        <P>
          This disclaimer is governed by the laws of India. Disputes are subject to the
          jurisdiction of the courts where {OPERATOR_NAME} operates.
        </P>
      </Section>

      <Section title="Questions">
        <ContactBlock email={CONTACT_EMAIL} operator={OPERATOR_NAME} />
      </Section>
    </div>
  )
}
